import { Component } from "@angular/core";
import {
    App,
    IonicPage,
    NavController,
    LoadingController,
    AlertController,
    MenuController,
    Platform,
} from "ionic-angular";
import { Validators, FormBuilder, FormGroup } from "@angular/forms";
import { UserProvider } from "../../providers/user";
import { MyController } from "../../app/my-controller";
import { NotificationsProvider } from "../../providers/notifications";
import { AppVersion } from "@ionic-native/app-version";

@IonicPage({
    segment: "login",
    priority: "high",
})
@Component({
    selector: "page-login",
    templateUrl: "login.html",
})
export class LoginPage extends MyController {
    protected restrict: boolean = false;

    public formLogin: FormGroup;
    public groupForm: any = "login";
    public version: string;

    constructor(
        _app: App,
        _menu: MenuController,
        platform: Platform,
        public navCtrl: NavController,
        public loadingCtrl: LoadingController,
        public alertCtrl: AlertController,
        public formBuilder: FormBuilder,
        public user: UserProvider,
        public notifications_m: NotificationsProvider,
        public appVersion: AppVersion
    ) {
        super(_app, _menu, user, platform);

        // Seta Validadores do form
        this.formLogin = formBuilder.group({
            email: ["", Validators.email],
            password: ["", Validators.required],
        });

        if (this.platform.is("cordova")) {
            this.appVersion.getVersionNumber().then((version: any) => {
                this.version = version;
                // if (version !== "2.5.63") {
                //     this.navCtrl.push("AtualizarPage");
                // }
            });
        } else {
            this.version = "WEB";
        }
    }

    onSubmit() {
        if (this.formLogin.valid) {
            let loader = this.loadingCtrl.create({
                content: "Aguarde...",
                spinner: "crescent",
                dismissOnPageChange: true,
            });

            loader.present();
            let data = {
                email: this.formLogin.value["email"],
                password: this.formLogin.value["password"],
            };

            this.user.get("deviceId").then((udid) => {
                if (udid != false) {
                    data["udid"] = udid;
                }

                this.user.login(data).then(
                    (data: any) => {
                        // Lógica primeiro login do Associado
                        let firstLogin: boolean = !parseInt(
                            data.data.already_logged
                        );
                        console.log("Primeiro Login?: ", firstLogin);
                        if (firstLogin) {
                            // Agenda a notificação de boas vindas caso seja o primeiro login.
                            this.notifications_m.schedulePushWelcome();
                        }

                        this.navCtrl.setRoot(
                            "HomePage",
                            { visualizar_termo: true },
                            { animate: true, direction: "forward" }
                        );
                    },
                    (error) => {
                        loader.dismiss();

                        let alert = this.alertCtrl.create({
                            title: "Ops!",
                            message: error,
                            buttons: ["Fechar"],
                        });
                        alert.present();
                    }
                );
            });
        }
    }

    openForgot() {
        this.navCtrl.push("EsqueciMinhaSenhaPage");
    }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts